import { Link } from 'react-router';
import { Ures } from '../ui/elemek.tsx';

export default function NincsOldal() {
  return (
    <Ures cim="Nincs ilyen oldal" szoveg="Az oldal nem található, vagy nincs hozzá hozzáférésed.">
      <Link to="/leadek" className="text-kiemelt underline">Vissza a leadekhez</Link>
    </Ures>
  );
}
